export default __webpack_public_path__ + "static/media/chevron-down.b248fcfa.svg";